'use client';
import cl from 'clsx';
import React, {useEffect, useRef, useState} from 'react';
import Image from 'next/image';
import arrow from '@/public/icons/arrow-hero.svg';
import Button from '@/ui/button';
import Label from '@/ui/label';
import ModalContactForm from '../modal-contact-form';
import styles from './styles.module.css';
import useAuthStore from '@/store/auth';
import ContactForm from '@/app/[lang]/contacts/contact-form-contact-page';
import Link from 'next/link';
import useLanguagesStore from "@/store/languages";

export default function Hero({dict, lang}) {
    const setLanguage = useLanguagesStore((state) => state.setLanguage)
    const hydrate = useAuthStore((state) => state.hydrate);
    const refreshAccessToken = useAuthStore((state) => state.refreshAccessToken);
    const stayLoggedIn = useAuthStore((state) => state.stayLoggedIn);
    const [isLabelVisible, setIsLabelVisible] = useState(false);
    const [isScreenLarge, setIsScreenLarge] = useState(false);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const labelRef = useRef(null);
    const hoverRef = useRef(null);
    const apiUrl = (process.env.NEXT_PUBLIC_API_URL || '').replace(/\/$/, '');

    React.useEffect(() => {
        setLanguage(lang);
    }, [lang]);

    useEffect(() => {
        hydrate();
    }, [hydrate, refreshAccessToken, stayLoggedIn]);

    const openModal = () => setIsModalOpen(true);
    const closeModal = () => setIsModalOpen(false);

    useEffect(() => {
        const checkScreenSize = () => {
            setIsScreenLarge(window.innerWidth >= 600);
        };
        checkScreenSize();
        window.addEventListener('resize', checkScreenSize);
        return () => {
            window.removeEventListener('resize', checkScreenSize);
        };
    }, []);

    useEffect(() => {
        const handleMouseMove = (event) => {
            if (isLabelVisible && labelRef.current) {
                labelRef.current.style.visibility = 'visible';
                labelRef.current.style.top = `${event.clientY - 120}px`;
                labelRef.current.style.left = `${event.clientX + 10}px`;
            }
        };
        if (labelRef.current) {
            labelRef.current.style.visibility = 'hidden';
        }
        document.addEventListener('mousemove', handleMouseMove);

        return () => {
            document.removeEventListener('mousemove', handleMouseMove);
        };
    }, [isLabelVisible, isScreenLarge]);


    const handleOverlayClick = (event) => {
        if (event.target.id === "modal-contact-form") {
            closeModal();
        }
    };

    const handleKeyDown = (event) => {
        if (event.key === "Escape") {
            closeModal();
        }
    };

    useEffect(() => {
        if (isModalOpen) {
            document.addEventListener("mousedown", handleOverlayClick);
            document.addEventListener("keydown", handleKeyDown);
        }
        return () => {
            document.removeEventListener("mousedown", handleOverlayClick);
            document.removeEventListener("keydown", handleKeyDown);
        };
    }, [isModalOpen]);

    return (
        <section className={cl(styles.hero, 'container')}>
            <h1 className={styles.hero__title}>
                {dict.hero.title1}{' '}
                <div className={styles.hero_title_bottom}>
                    <span className={styles.hero__arrow_right}>
                        <Image src={arrow} alt='arrow-left'/>
                    </span>{' '}
                    <span
                        ref={hoverRef}
                        className={styles.hero__underline}
                        onMouseEnter={() => setIsLabelVisible(true)}
                        onMouseLeave={() => setIsLabelVisible(false)}
                    >
                        <Link href={`${apiUrl}/media/upload_data/About%20Circular%20Economy.pdf`}
                              target='_blank'>
                            {dict.hero.title2}
                        </Link>
                    </span>
                    <span className={styles.hero__arrow_left}>
                        <Image src={arrow} alt='arrow-left'/>
                    </span>{' '}
                    {dict.hero.title3}
                </div>
            </h1>

            <div className={styles.hero__talk}>
                <Button
                    type='round-top-right'
                    externalText={dict.hero.buttonTalk}
                    section='hero'
                    onClick={openModal}
                />
            </div>
            {isLabelVisible && isScreenLarge && <Label title={dict.hero.about_circular} ref={labelRef}/>}
            <ModalContactForm
                isOpen={isModalOpen}
                onClose={closeModal}
                type={'contact-form-main'}
            >
                <ContactForm dict={dict} />
            </ModalContactForm>
        </section>
    );
}
